import React, { useCallback, useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import css from './modal.module.css';

// Using http://reactcommunity.org/react-modal/
export default function Modal({
  visible = true,
  buttons = null,
  title = null,
  name = 'modal',
  body = null,
  onAfterOpen = null,
  onClose = null,
  shouldCloseOnOverlayClick = true,
  className = null,
  overlayColor,
  overlayClassName = 'overlay',
  classNameBody = null,
  contentClassName = 'content',
  buttonsClassName = 'buttons',
  customOverlayClassName = '',
}: {
  visible: boolean;
  buttons: React.ReactNode;
  title?: React.ReactNode | string;
  body?: React.ReactNode | string;
  name?: string;
  onAfterOpen?: () => void;
  onClose: () => void;
  shouldCloseOnOverlayClick?: boolean;
  overlayClassName?: string;
  overlayColor?: string;
  className?: string;
  classNameBody?: string;
  contentClassName?: string;
  buttonsClassName?: string;
  customOverlayClassName?: string;
}) {
  const [modalVisible, setModalVisible] = useState(visible);
  useEffect(() => setModalVisible(visible), [visible]);

  const closeModal = useCallback(() => {
    setModalVisible(false);
    onClose();
  }, [setModalVisible, onClose]);

  return (
    <ReactModal
      isOpen={modalVisible}
      onAfterOpen={onAfterOpen}
      onRequestClose={closeModal}
      className={`${css['modal']} ${css[className]} ${className}`}
      overlayClassName={`${css[overlayClassName]} ${customOverlayClassName}`}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      style={{
        overlay: {
          backgroundColor: overlayColor,
        },
      }}
    >
      <div className={css[contentClassName]} data-name={name}>
        {title && <div className={css['title']}>{title}</div>}
        {body && <div className={classNameBody ?? css['body']}>{body}</div>}
        {buttons && <div className={css[buttonsClassName]}>{buttons}</div>}
      </div>
    </ReactModal>
  );
}
